import React from 'react';

import Loadable from 'react-loadable';
import {Route, Redirect} from 'react-router-dom';

import LoadingSpinner from 'static/three-oh/src/components/LoadingSpinner/LoadingSpinner';
import {
  teacherOnboardingRoot,
  onboardingPath,
} from 'static/three-oh/src/modules/constants/routePaths';

const LazyTeacherOnboarding = Loadable({
  loader: () => import(
    /* webpackChunkName: "TeacherOnboarding" */
    './components/TeacherOnboarding'
  ),
  loading: LoadingSpinner,
});


const TeacherOnboardingRoute = [
  <Route
    key="TeacherOnboardingIndexRedirect"
    path={teacherOnboardingRoot}
    exact
    render={() => <Redirect to={onboardingPath + '/0'}/>}
  />,
  <Route
    key="TeacherOnboardingCatchAll"
    path={onboardingPath + '/:step(\\d+)'}
    component={LazyTeacherOnboarding}
  />,
];

export default TeacherOnboardingRoute;
